export enum ShortLinkType {
  CHECKOUT = 'checkout',
  CHECKOUT_ONE_CLICK = 'checkout_one_click',
  PRODUCT = 'product',
  PRODUCT_EXTERNAL = 'product_external',
  MEMBER_AREA = 'members_area',
  MEMBER_AREA_EXTERNAL = 'members_area_external',
}
